export const LINGUA_TITLE_KEY = {carousel_title: 'carousel.popularPlaceTitle'};
export const SERP_LARGE_SEARCH_TERM_DESTINATION =
    'SERP_LARGE_SEARCH_TERM_DESTINATION';
export const BREAKPOINTS = {
    '1200': 6.23,
    '992': 6.23,
    '768': 6.23,
    '480': 6.23,
    '0': 6
};
